import { INBOX } from '../productTypes'
import { selectCurrentPlanByType } from './selectCurrentPlanByType'

export const selectCurrentInbox = state => {
  return selectCurrentPlanByType(state, INBOX)
}
